import Swiper from 'swiper';
import { Pagination, Navigation, A11y } from 'swiper/modules';
import ControlSwiper from '../components/ControlSwiper';
import BackgroundVideo from '../components/BackgroundVideo';
import ADA from '../components/ADA';

const controlSwiper = new ControlSwiper();
export default class ModAdditionalFeaturesBlack {
  constructor(el) {
    this.$el = $(el);

    this.classes = {
      transitionDelay: 'delay-ins-6',
      opacityZero: 'opacity-0',
    };

    this.mySwiper = null;
    this.playerVideos = [];
    this.windowWidthCurrent = $(window).width();

    this.dom = {
      $swiper: this.$el.find('.swiper'),
      $swiperPagination: this.$el.find('.swiper-pagination'),
      $swiperButtonNext: this.$el.find('.swiper-button-next'),
      $swiperButtonPrevious: this.$el.find('.swiper-button-prev'),
      $buttonPlayPause: this.$el.find('.btn-play-pause'),
      $videos: this.$el.find('.js-video-swiper'),
      $initOpacity: this.$el.find('.init-opacity'),
      $swiperButtonBoth: this.$el.find('.swiper-button'),
    };

    this.adaInstance = new ADA();

    this.init();
  }

  init() {
    this.getPlayerVideo();
    this.addSwiper();
    this.addListeners();
  }

  addListeners() {
    $(window).on('orientationchange', () => {
      this.eventOrientationChangePlayOrPauseVideo();
    });
  }

  getPlayerVideo() {
    this.dom.$videos.each((index, elm) => {
      const player = new BackgroundVideo(elm);
      player.init();
      this.playerVideos.push(player);
      $(elm).attr('id', `${index}-${player.id}`);
    });
  }

  addSwiper() {
    this.mySwiper = new Swiper(this.dom.$swiper[0], {
      modules: [Pagination, Navigation, A11y],
      speed: 500,
      slidesPerView: 1,
      autoHeight: true,
      pagination: {
        el: this.dom.$swiperPagination[0],
        clickable: true,
      },
      navigation: {
        nextEl: this.dom.$swiperButtonNext[0],
        prevEl: this.dom.$swiperButtonPrevious[0],
      },
      breakpoints: {
        // when window width is >= 700px
        700: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
          autoHeight: false,
        },
      },
      on: {
        init: (event) => {
          this.dom.$swiperButtonPrevious.removeClass(this.classes.opacityZero);
          this.dom.$initOpacity.removeClass(this.classes.opacityZero);

          this.handleStyleSwiperButtonDisabled();

          const intervalTime = setInterval(() => {
            if (this.dom.$videos.find('.is-loaded-video').length >= this.dom.$buttonPlayPause.length) {
              controlSwiper.handlePauseOrPlayVideo(event, this.$el, this.playerVideos);
              clearTimeout(intervalTime);
            }
          }, 500);
        },
        slideChange: (event) => {
          this.dom.$swiperButtonBoth.removeAttr('style');
          this.handleStyleSwiperButtonDisabled();

          if (this.dom.$swiperButtonBoth.hasClass(this.classes.transitionDelay)) {
            this.dom.$swiperButtonBoth.removeClass(this.classes.transitionDelay);
          }

          controlSwiper.handlePauseOrPlayVideo(event, this.$el, this.playerVideos);
        },
        transitionEnd: () => {
          this.adaInstance.removeAttrAriaDisabled(this.$el);
        },
      },
    });
    this.adaInstance.removeAttrAriaDisabled(this.$el);
  }

  handleStyleSwiperButtonDisabled() {
    this.$el.find('.swiper-button-disabled').css({
      'opacity': '0',
      'pointer-events': 'none',
    });
  }

  eventOrientationChangePlayOrPauseVideo() {
    const intervalTime = setInterval(() => {
      const windowWidthOrientationChange = $(window).width();
      if (this.windowWidthCurrent !== windowWidthOrientationChange) {
        this.windowWidthCurrent = windowWidthOrientationChange;
        controlSwiper.handlePauseOrPlayVideo(this.mySwiper, this.$el, this.playerVideos);
        clearTimeout(intervalTime);
      }
    }, 100);
  }
}
